import { Component, OnInit } from '@angular/core';
import { Router } from "@angular/router";
import { EmpresaService } from '../../../../services/empresa.service';
import { GrupoService } from '../../../../services/grupo.service';

@Component({
  selector: 'app-establecimientos',
  templateUrl: './establecimientos.component.html',
  styleUrls: ['./establecimientos.component.css'],
  providers: [EmpresaService, GrupoService]
})
export class EstablecimientosComponent implements OnInit {
  public token: any
  public status: any
  public message_success: any
  public message_error: any
  public medio_de_alta: any
  public showAutomatico
  public showPorNombre
  public showEstablecimientos
  public empresas: any

  constructor(
    private _router: Router,
    private _grupoService: GrupoService,
    private _empresaService: EmpresaService,
  ) {
    this.token = this._grupoService.getToken();
  }

  ngOnInit() {
  }

  chooseTypeAdd() {
    let tipo = $('input:radio[name=tipoAlta]:checked').val();
    if (tipo == 'automatico') {
      this.showAutomatico = true
      this.showPorNombre = false
    } else {
      this.showPorNombre = true
      this.showAutomatico = false
    }
  }

  vincularEstablecimientos() {
    $(".loading").show();
    this._empresaService.vincularEmpresa(this.token).subscribe(
      response => {
        // Obtener el token 
        if (response.status == 'success') {
          $(".loading").hide();
          $(".vinculacion").show();
          this.status = 'success'
          this.message_success = response.message;
          setTimeout(function () {
            $(".vinculacion").fadeTo(500, 1).slideUp(500, function () {
              $(".vinculacion").hide();
            });
          }, 3000);
        }
      },
      error => {
        if (error['status'] == 401) {
          this._router.navigate(['logout/1']);
        } else {
          $(".loading").hide();
          $(".vinculacion").show();
          this.status = 'error'
          this.message_error = error.error.message;
          setTimeout(function () {
            $(".vinculacion").fadeTo(500, 1).slideUp(500, function () {
              $(".vinculacion").hide();
            });
          }, 3000);
        }
      }
    );
  }

  buscarEmpresa() {
    let empresa = $("#establecimiento").val();
    let data = { empresa }
    $(".loading").show();
    this._empresaService.findEmpresa(this.token, data).subscribe(
      response => {
        $(".loading").hide();
        $(".vinculacion").show();
        this.empresas = response.empresas
        this.status = 'success'
        this.message_success = response.message;
        this.showEstablecimientos = true
        setTimeout(function () {
          $(".vinculacion").fadeTo(500, 1).slideUp(500, function () {
            $(".vinculacion").hide();
          });
        }, 3000);
      },
      error => {
        if (error['status'] == 401) {
          this._router.navigate(['logout/1']);
        } else {
          $(".loading").hide();
          $(".vinculacion").show();
          this.status = 'error'
          this.message_error = error.error.message;
          setTimeout(function () {
            $(".vinculacion").fadeTo(500, 1).slideUp(500, function () {
              $(".vinculacion").hide();
            });
          }, 3000);
        }
      }
    );
  }

  agregarEmpresa(empresa) {
    $(".loading").show();
    this._empresaService.addEmpresa(this.token, empresa).subscribe(
      response => {
        $(".loading").hide();
        $(".vinculacion").show();
        this.status = 'success'
        this.message_success = response.message;
        this.showEstablecimientos = false
        setTimeout(function () {
          $(".vinculacion").fadeTo(500, 1).slideUp(500, function () {
            $(".vinculacion").hide();
          });
        }, 3000);
      },
      error => {
        if (error['status'] == 401) {
          this._router.navigate(['logout/1']);
        } else {
          $(".loading").hide();
          $(".vinculacion").show();
          this.status = 'error'
          this.message_error = error.error.message;
          this.showEstablecimientos = false
          setTimeout(function () {
            $(".vinculacion").fadeTo(500, 1).slideUp(500, function () {
              $(".vinculacion").hide();
            });
          }, 3000);
        }
      }
    );
  }

}
